import { useTranslations } from 'next-intl'

/**
 * "The Window Seat" masthead wordmark, shown in the global navbar on blog
 * routes alongside the Wanderu logo. Presentational only — the navbar wraps it
 * in a link to the blog home (via `brandUrl`). The tagline is hidden on the
 * narrowest viewports to keep the mobile navbar uncrowded.
 */
export const BlogWordmark = () => {
    const t = useTranslations('blogHome.masthead')

    return (
        <div className="flex flex-col leading-none">
            <span className="text-base font-bold tracking-tight whitespace-nowrap text-text-primary max-sm:truncate md:text-lg">
                {t('title')}
            </span>
            <span className="mt-0.5 hidden text-[10px] font-semibold text-text-secondary sm:block md:text-[11px]">
                {t('tagline')}
            </span>
        </div>
    )
}
